import React from 'react'
import styles from './styles.module.scss'

function ProfileChallengeText({ text, className }) {
  return <h3 className={`${styles.challangeTitle} ${className}`} dangerouslySetInnerHTML={{ __html: text }} />
}

export default ProfileChallengeText
